import React, { Component } from 'react';
import { getUserType } from "../../services/auth";
import { Link } from 'react-router-dom';
import api from '../../services/api';
import { archiveKey, readArchive, writeArchive, snapshotList } from '../../services/history-archive';
//import SelectPure from "select-pure";

import Header from '../../components/header';
import TitlePage from '../../components/title-page';
// import Search from '../../components/search';
import EmailPreview from '../../components/email-preview';
import Search from '../../components/search';



import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

// import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
// import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
// import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
// import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';

//images
import logoPartner from '../../assets/img/partner/fort-giants/logo-partner.png';

export default class project extends Component {
	state = {
		search: "",
		selectedPublishers: [], 
		//getPublisherNames: [],
		//selectedPublishersSort: 'A-Z',
		order: "First",
		user_type: "",
		company_id: 0,
		project_id: 0,
		company_name: "",
		company_description: "",
		logo_src: "",
		project_title: "",
		banner_title: "",
		banner_description: "",
		banner_src: "",
		links: [],
		publishers: [],
		list_selections: [],
		new_list: false,
		checkedItens: [],
		contacts: [],
		messages: [],
		available_links: [],
		selected_list: 0,
		modal_publishers: "closed",
		modal_message: "closed",
		modal_unlock_files: "closed",
		modal_delete: "closed",
		modal_send: "closed",
		modal_status: "closed",
		modal_submitted: "closed",
		modal_preview: 'closed',
		preview_subject: "",
		preview_cc: "",
		preview_message: "",
		default_message: "",
		sent_at: "",
		subject: "",
		cc: [],
		message: "",
		chat_modal: "closed",
		chat_message: "",
		render_update: false,
		submissionLists: [],
		submissionListsCC: [],
		selectedSubmissionList: null,
		selectedContacts: {},
		loading_lists: true,
		lists_error: "",
		dispatch_progress: null,
		type_list: "publishers",
		send_to: 'all',
		modal_details_id : -1,
		schedule_inputs: {},
		schedule_target: null,
		schedule_error: "",
		modal_schedule: "closed",
		modal_last_sent: "closed",
		last_sent_target: null,
		history_open: false,
		history_loading: false,
		history_error: ""
	}

	// Fuera del state: solo marca si los archivos del historial ya se pidieron,
	// no se pinta en ningun sitio y no tiene por que disparar un render.
	history_files_ready = false

	getPublisherNames = (submissionList) => {
	const { publishers = [] } = this.state;

	// Filtramos todos los contactos de tipo "publisher"
	const contactPublishers = submissionList.contacts?.filter(
		(c) => c.contact_type === "publisher"
	) || [];

	// Buscamos el nombre de cada publisher según su contact_id
	const names = contactPublishers.map((contactPublisher) => {
		const publisher = publishers.find(p => p.id === contactPublisher.contact_id);
		return publisher ? (publisher.contact_name || publisher.name || '') : '';
	});

	// Quitamos vacíos y retornamos un arreglo con todos los nombres
	return names.filter(Boolean);
};




	async componentDidMount() {
  document.querySelector('body').classList.remove("no-scroll");

  const company_id = this.props.match.params.company_id;
  const project_id = this.props.match.params.project_id;

  this.setState({ company_id, project_id });

  //  Restaurar publishers seleccionados de ESTE proyecto
  this.restoreSelectedPublishers(project_id);

  const currentUser = getUserType();
  if (currentUser === "admin") {
    this.setState({ user_type: "admin" });
    await this.loadPublishers(company_id, project_id);
    await this.loadCategories(company_id, project_id);
  } else {
    this.setState({
      user_type: "normal",
      type_list: "categories"
    });
    await this.loadCategories(company_id, project_id);
  }

  await this.loadApiProject(company_id, project_id);
  await this.loadLists();
  
}


	loadApiProject = async (company_id, project_id) => {
		try {
			const response = await api.get(`companies/${company_id}/projects/${project_id}`);
			const response2 = await api.get(`companies/${company_id}/projects/${project_id}/banner`);
			const response3 = await api.get(`companies/${company_id}/projects/${project_id}/files`);
			//const response4 = await api.get(`project_submission_list/${project_id}`)

			await this.setState({
				project_type: response.data.project_type,
				project_title: response.data.title, 
				company_name: response.data.company_name,
				//sent_at: response.data.sent_at,
				company_description: response.data.company_description,
				banner_title: response2.data.title,
				banner_description: response2.data.description,
				links: response3.data,
			});

			if(response.data.logo_url) {
				this.setState({
					logo_src: 'https://seat7-uploads.s3.amazonaws.com/'+response.data.logo_url,
				})
			}

			if(response2.data.image_url) {
				this.setState({
					banner_src: 'https://seat7-uploads.s3.amazonaws.com/'+response2.data.image_url,
				})
			}
		} catch (error) {
			console.log(error);
		}
	}

    	// ----------------------------------------------------
	// LOAD PUBLISHER LIST --------------------------------
	// ----------------------------------------------------
	loadPublishers = async (company_id, project_id) => {
		try {
			const response = await api.get(`publishers`);
			const publishers = response.data || []
			await this.loadCollaborators(publishers);

			return this.setState({
				publishers,
				checkedItens: []
			});
		} catch (error) {
			console.log(error);
		}
	}
    
	
	// En lotes en vez de una peticion simultanea por publisher (son mas de 250):
	// menos presion sobre la API y menos timeouts, que es lo que disparaba el
	// fallo de carga. loadPublisherCollaborators ya nunca rechaza.
	COLLABORATORS_BATCH_SIZE = 12

	loadCollaborators = async (publishers) => {
		for (let i = 0; i < publishers.length; i += this.COLLABORATORS_BATCH_SIZE) {
			const batch = publishers.slice(i, i + this.COLLABORATORS_BATCH_SIZE);
			await Promise.all(batch.map(this.loadPublisherCollaborators));
		}
	}
	
	loadCollaboratorsCC = async (publishers) => {
		try {
			const collaboratorsPromises = publishers.map(this.loadPublisherCollaboratorsCC)
			return Promise.all(collaboratorsPromises);
		} catch (error) {
			console.log(error);
		}
	}

	loadPublisherCollaborators = async (publisher) => {
		try {
			const collaboratorsRequest = await api.get(`publishers/${publisher.id}/employees`)
			publisher.collaborators = collaboratorsRequest.data || []
		} catch (error) {
			// Un fallo aislado no puede tumbar la lista entera: antes el rechazo subia
			// al Promise.all, saltaba al catch de loadPublishers y el setState con los
			// publishers no llegaba a ejecutarse, dejando el modal vacio y sin aviso.
			console.log(error);
			publisher.collaborators = []
		}

		return publisher.collaborators
	}


	
	


	componentWillUnmount() {
		if (this.queueTimer) {
			clearInterval(this.queueTimer);
			this.queueTimer = null;
		}
	}

	// ----------------------------------------------------
	// SELECCION PERSISTIDA -------------------------------
	// ----------------------------------------------------

	selectedPublishersKey = (project_id) => `selectedPublishers:${project_id}`

	// La clave lleva el proyecto: con una sola clave global, lo marcado en un
	// proyecto aparecia como seleccionado en otro. Y el parse va protegido:
	// un valor corrupto lanzaba dentro de componentDidMount y dejaba la pagina
	// en blanco antes de cargar nada.
	restoreSelectedPublishers = (project_id) => {
		try {
			const stored = localStorage.getItem(this.selectedPublishersKey(project_id));

			if (stored) {
				this.setState({selectedPublishers: JSON.parse(stored)});
			}
		} catch (error) {
			console.log(error);
			this.setState({selectedPublishers: []});
		}
	}

	persistSelectedPublishers = (publishers) => {
		try {
			localStorage.setItem(
				this.selectedPublishersKey(this.state.project_id),
				JSON.stringify(publishers)
			);
		} catch (error) {
			console.log(error);
		}
	}

	// ----------------------------------------------------
	// BUSCADOR -------------------------------------------
	// ----------------------------------------------------

	onSearchChange = (e) => {
		this.setState({search: e.target.value});
	}

	// El buscador es un <form>. Sin preventDefault, Enter o el boton de la lupa
	// lo envian y recargan la SPA, cerrando el modal y perdiendo la seleccion.
	// El filtrado ya ocurre al teclear, asi que el submit no tiene que hacer nada.
	onSearchSubmit = (e) => {
		e.preventDefault();
	}

	// Se filtra en el momento de render a partir del texto, en vez de guardar una
	// lista ya filtrada: asi no queda un filtro viejo pegado al reabrir el modal,
	// y la misma funcion sirve para publishers y para categorias de prensa.
	filterBySearch = (items) => {
		const term = (this.state.search || "").trim().toLowerCase();

		if (!term) {
			return items;
		}

		return items.filter(item => {
			// Coercion defensiva: un publisher sin tags hacia reventar el filtro y,
			// como el error caia en un catch, la busqueda dejaba de responder entera.
			const name = (item.name || "").toLowerCase();
			const tags = (item.tags || "").toLowerCase();

			return name.includes(term) || tags.includes(term);
		});
	}

	loadPublisherCollaboratorsCC = async (publisher) => {
		const collaboratorsRequest = await api.get(`publishers/${publisher.id}/employeescc`)
		publisher.collaborators = collaboratorsRequest.data || []

		return publisher.collaborators
	}

	// ----------------------------------------------------
	// LOAD CONTACT LIST ----------------------------------
	// ----------------------------------------------------
	loadCategories = async (company_id) => {
		try {
			const response = await api.get(`companies/${company_id}/presses`);
			const categories = response.data || []
			await this.loadContacts(categories);

			const newCategories = categories.map(category => {
				const newCategory = {
					company_id: category.company_id,
					contact_name: category.name,
					name: category.name,
					email: "",
					id: category.id,
					collaborators: category.contacts
				}

				return newCategory;
			})

			return this.setState({
				categories: newCategories,
				checkedItens: []
			});
		} catch (error) {
			console.log(error);
		}
	}
	
	loadContacts = async (categories) => {
		try {
			const contactsPromises = categories.map(this.loadCategoriesContacts)
			return Promise.all(contactsPromises);
		} catch (error) {
			console.log(error);
		}
	}

	loadCategoriesContacts = async (category) => {
		const { company_id } = this.state;
		const contactsRequest = await api.get(`companies/${company_id}/presses/${category.id}/contacts`)
		category.contacts = contactsRequest.data || []

		return category.contacts
	}
	

	// `silent` evita encender el loader: los refrescos automaticos mientras hay
	// grupos en cola no deben hacer parpadear la tabla cada pocos segundos.
	loadLists = async (silent) => {
		if (!silent) {
			this.setState({loading_lists: true, lists_error: ""});
		}

		try {
			const {company_id, project_id} = this.state
			const responseList = await api.get(`/companies/${company_id}/projects/${project_id}/submission-lists`)

			const submissionLists = responseList.data || []
			const contactsPromises = submissionLists.map(this.loadSubmissionListContacts)
			let contacts = await Promise.all(contactsPromises);

			// Los ids salen de la respuesta completa, antes del filtro: un grupo sin
			// contactos sigue existiendo en la API y no debe darse por borrado.
			const live_ids = new Set(submissionLists.map(list => list.id));

			const tempList = submissionLists.filter(item => item.contacts.length > 0);

			this.setState({
				submissionLists: tempList,
				contacts
			});

			this.syncHistoryArchive(tempList, live_ids);

			// Los objetos de lista vienen nuevos y sin `files`, asi que lo que el
			// historial tuviera cacheado ya no esta pegado a ellos. Si el panel esta
			// abierto se repiten las peticiones en silencio para que no parpadee con
			// cada refresco automatico de la cola.
			this.history_files_ready = false;

			if (this.state.history_open) {
				await this.loadHistoryFiles(true);
			}
		} catch (error) {
			console.log(error);
			this.setState({
				submissionLists: [],
				lists_error: "The message groups could not be loaded. Please try again."
			});
		} finally {
			// Apagar el loader pase lo que pase. Dejarlo encendido en el catch era
			// lo que convertia cualquier fallo de la API en un spinner eterno sin
			// mensaje ni forma de reintentar.
			this.setState({loading_lists: false});
			this.syncQueueWatcher();
		}
	}
	

	loadSubmissionListContacts = async (submissionList) => {
		const contactsRequest = await api.get(`/project_submission_lists/${submissionList.id}/contacts`)
		submissionList.contacts = contactsRequest.data || []
		
		return submissionList.contacts;
	}

	onChange = (e) => {
		this.setState({
			[e.target.name]: e.target.value,
		});
	}

	async setSelectedSubmissionList (selectedSubmissionList) {
		return this.setState({
			selectedSubmissionList
		})
	}

	// Functions to modal Publisher
	async modalPublishers (status, submissionList = null) {
		// Cerrar no debe rehacer la ruta de apertura: hacerlo reemplazaba la lista
		// seleccionada por una vacia con id 0 y tiraba la seleccion en curso.
		if (status !== 'opened') {
			return this.setState({modal_publishers: 'closed'});
		}

		await this.setSelectedSubmissionList(submissionList || this.newSubmissionListObject())
		const {selectedSubmissionList} = this.state
		const {contacts} = selectedSubmissionList

		// Objeto, no array: el resto del codigo lo indexa por clave de contacto.
		// Y el buscador arranca limpio en cada apertura.
		await this.setState({
			selectedContacts: {},
			search: ""
		})

		for (const contact of contacts) {
			await this.toggleSelectContact(contact.contact_type, contact.contact_id, contact.contact_email, true)
		}

		this.setState({
			// new_list: id === 0 ? true : false,
			modal_publishers: status,
			// selected_list: id
		});
	}

	closePublishersModal () {
		document.querySelector('.modal-list-publishers .save-container .link').classList.remove("load");
		this.setState({
			modal_publishers: 'closed'
		})
	}

	async toggleSelectContact (contact_type, contact_id, contact_email, forceSelected = null) {
		const selectedContacts = { ...this.state.selectedContacts }
		const contactKey = `${contact_type}-${contact_id}`
		const contact = selectedContacts[contactKey]
		const newCheckedState = forceSelected !== null ? forceSelected : !!contact === false

		if (!newCheckedState) {
			delete selectedContacts[contactKey]
		} else {
			selectedContacts[contactKey] = {
				contact_type,
				contact_id,
				contact_email
			}
		}

		this.setState({
			selectedContacts
		})
	}

	toggleListType = (type) => {
		this.setState({ type_list: type })
	}

	async toggleAllPublisherContacts(publisher) {
		const allChecked = this.publisherAllContactsSelected(publisher);
		const collaborators = publisher.collaborators || [];

		await this.toggleSelectContact('publisher', publisher.id, publisher.email, !allChecked);

		for (const collaborator of collaborators) {
			await this.toggleSelectContact('publisher_employee', collaborator.id, collaborator.email, !allChecked);
		}

		// El badge "Selected" refleja exactamente el estado de los contactos: se
		// deriva de !allChecked en vez de consultar si ya estaba en la lista. La
		// condicion anterior (exists || allChecked) lo quitaba en el mismo clic que
		// marcaba los contactos cuando la seleccion venia restaurada de localStorage,
		// y hacian falta tres clics para que badge y checkbox volvieran a coincidir.
		const shouldBeSelected = !allChecked;

		this.setState(
			prevState => {
				const without = prevState.selectedPublishers.filter(item => item.id !== publisher.id);

				return {selectedPublishers: shouldBeSelected ? [...without, publisher] : without};
			},
			// La escritura va en el callback, no dentro del updater: un updater debe
			// ser puro y React puede llegar a invocarlo mas de una vez.
			() => this.persistSelectedPublishers(this.state.selectedPublishers)
		);
	}

	publisherAllContactsSelected (publisher) {
		const {selectedContacts} = this.state
		// collaborators queda sin asignar si su peticion fallo al cargar.
		const collaborators = publisher.collaborators || []
		const checkedPublisherCollaborators = collaborators.filter(
			collaborator => 
				!!selectedContacts[`publisher_employee-${collaborator.id}`]
			)
		const allChecked = checkedPublisherCollaborators.length === collaborators.length && !!selectedContacts[`publisher-${publisher.id}`]
		return allChecked
	}

	async toggleAllCategoryContacts (category) {
		const allChecked = this.categoryAllContactsSelected(category)
		for (const collaborator of (category.collaborators || [])) {
			await this.toggleSelectContact('press_contact', collaborator.id, collaborator.email, !allChecked)
		}
	}

	categoryAllContactsSelected (category) {
		const {selectedContacts} = this.state
		const collaborators = category.collaborators || []
		const checkedCategoryContacts = collaborators.filter(
			collaborator => 
				!!selectedContacts[`press_contact-${collaborator.id}`]
			)
		// Una categoria vacia no esta "toda seleccionada": sin esto, 0 === 0 la
		// pintaba marcada.
		const allChecked = collaborators.length > 0 && checkedCategoryContacts.length === collaborators.length
		return allChecked
	}

	async insertContact (submission_list_id, contact) {
		try {
			const response = await api.post(`/project_submission_lists/${submission_list_id}/contacts`, contact)
			return response.data
		} catch (error) {
			console.log(error);
		}
	}

	async removeContact (contact) {
		if (contact.id && contact.list_id) {
			try {
				const response = api.delete(`/project_submission_lists/${contact.list_id}/contacts/${contact.id}`)
				
				return response
			} catch (error) {
				console.log(error);
			}
		}
	}

    async saveListContacts () {
			document.querySelector('.modal-list-publishers .save-container .link').classList.add("load");
			let {selectedSubmissionList, selectedContacts} = this.state
			const contactsWithEmail = Object.values(selectedContacts).filter(contact => contact.contact_email)
			const contacts2Delete = selectedSubmissionList.contacts.filter(oldContact => !!selectedContacts[`${oldContact.contact_type}-${oldContact.contact_id}`] === false)
			const contacts2Insert = contactsWithEmail.filter(
				selectedContact => !!selectedSubmissionList.contacts.find(
					old => old.contact_id === selectedContact.contact_id && old.contact_type === selectedContact.contact_type
				) === false
			)

			if (!contacts2Insert.length && !contacts2Delete.length) {
				this.closePublishersModal()
				return;
			}
			
			if (selectedSubmissionList.id === 0) {
				selectedSubmissionList = await this.saveNewList()
			}

			const insertPromises = contacts2Insert.map(contact => this.insertContact(selectedSubmissionList.id, contact))
			const deletePromises = contacts2Delete.map(this.removeContact)

			await Promise.all([...insertPromises, ...deletePromises])
			await this.loadLists()
			this.closePublishersModal()
    }

	closeMessageModal () {
		document.querySelector('.modal-write-message .btn-save').classList.remove("load");

		console.log("closeMessageModal");
		this.setState({
			subject: "",
			cc:"",
			message: "",
			modal_message: 'closed'
		})
	}

	openMessageModal (submissionList) {
		const {subject, cc, message} = submissionList
		this.setSelectedSubmissionList(submissionList)
		// console.log(submissionList);

		let temp_default_message = "";

		if(this.state.project_type === "finished"){
			temp_default_message = `It's my pleasure to bring your attention to <b>${this.state.project_title}</b> in development by <i>${this.state.company_name}.</i><br /><br /> You will find available the submission materials for your consideration by clicking on "View Details:"<br /><br />  <img src=${this.state.banner_src} width= "308px" height= "175px"></img>`
			this.setState({
				default_message:   `It's my pleasure to bring your attention to <b>${this.state.project_title}</b> in development by <i>${this.state.company_name}.</i><br /><br /> You will find available the submission materials for your consideration by clicking on "View Details:"<br /><br /> <img src=${this.state.banner_src} width= "308px" height= "175px"></img>`
			});
		} else if(this.state.project_type === "production") {
			temp_default_message = `It's my pleasure to bring your attention to <b>${this.state.project_title}</b> in development by <i>${this.state.company_name}.</i><br /><br /> You will find available the submission materials for your consideration by clicking on "View Details:"<br /><br /> <img src=${this.state.banner_src} width= "308px" height= "175px"></img>`
			this.setState({
				default_message: `It's my pleasure to bring your attention to <b>${this.state.project_title}</b> in development by <i>${this.state.company_name}.</i><br /><br /> You will find available the submission materials for your consideration by clicking on "View Details:"<br /><br />  <img src=${this.state.banner_src} width= "308px" height= "175px"></img>`
			}); 
		}

		this.setState({
			modal_message: 'opened',
			subject: subject || '',
			cc: cc || '',
			message: message || temp_default_message,
		})
	}

	modal_preview (submissionList) {
		const {subject, cc, message} = submissionList
		this.setSelectedSubmissionList(submissionList);

		this.setState({
			modal_preview: 'opened',
			preview_subject: subject || '',
			preview_cc: cc || '',
			preview_message: message || '',
		})
	}

	closePreviewEmailModal () {
		this.setState({
			preview_subject: "",
			preview_cc: "",
			modal_preview: 'closed'
		})
	}

	
	async saveMessage (e, status) {
		e.preventDefault();
		document.querySelector('.modal-write-message .btn-save').classList.add("load");
		var {selectedSubmissionList, project_id, subject, cc, default_message, message} = this.state

		//Elimina elementos Figure y Figcaption que se autoagregan al editar el correo cuando contiene una o varias imagenes
		while(message.indexOf('<figure class="image">') != -1)
		{
			message = message.slice(0,message.indexOf('<figure class="image">')) + message.slice(message.indexOf('<figure class="image">')+('<figure class="image">'.length),message.length)
			message = message.slice(0,message.indexOf('</figure>')) + message.slice(message.indexOf('</figure>')+('</figure>'.length),message.length)

			if(message.indexOf('<figcaption') != -1)
			{
				message = message.slice(0,message.indexOf('<figcaption')) + message.slice(message.indexOf('</figcaption>')+('</figcaption>'.length),message.length)

			}

		}

		try {
			await api.put(`/project_submission_lists/${selectedSubmissionList.id}`, {project_id, subject, cc, message})

			await this.loadLists();
			this.closeMessageModal();
		} catch (err) {
			console.log(err);
		}
	}

    async loadSubmissionListFiles (submissionList) {
        try {
            const response = await api.get(`/project_submission_lists/${submissionList.id}/files`);
            submissionList.files = response.data || []
            return submissionList.files
        } catch (err) {
            console.log(err)
        }
    }

	closeUnlockFilesModal () {
		document.querySelector('.modal-unlock-files .save-container .link').classList.remove("load");
		this.setState({
			modal_unlock_files: 'closed'
		});
	}

	async openUnlockFilesModal (submissionList) {
		await this.setSelectedSubmissionList(submissionList)
		await this.loadSubmissionListFiles(submissionList)

		let {available_links} = this.state
		available_links = submissionList.files.map(listFile => listFile.file_id)

		this.setState({
			modal_unlock_files: 'opened',
			available_links
		});
	}

	avaliableLink (link, status) {
		let available_links = [...this.state.available_links]
		const index = available_links.indexOf(link.id)
		if (index > -1) {
			available_links.splice(index, 1)
		}

		if (status) {
			available_links.push(link.id)
		}

		this.setState({
			available_links
		})
	}

	async saveNewList () {
		const { project_id } = this.state;
		try {
			const response = await api.post(`/project_submission_lists`, { project_id })

			return response.data
		} catch (error) {
			console.log(error);
		}
	}

    async insertFile (list_id, file_id) {
        try {
            return api.post(`/project_submission_lists/${list_id}/files`, {file_id})
        } catch (err) {
            console.log(err);
        }
    }

    async removeFile (listFile) {
        try {
            return api.delete(`/project_submission_lists/${listFile.list_id}/files/${listFile.id}`)
        } catch (err) {
            console.log(err);
        }
    }

	async saveAvaliableLinks () {
		document.querySelector('.modal-unlock-files .save-container .link').classList.add("load");
		const {available_links, selectedSubmissionList} = this.state;
		const _files2Remove = selectedSubmissionList.files.filter(listFile => !available_links.includes(listFile.file_id))
		const _files2Insert = available_links.filter(
			file_id => (!!selectedSubmissionList.files.find(listFile => listFile.file_id === file_id) === false)
		)

		const insertPromises = _files2Insert.map(file_id => this.insertFile(selectedSubmissionList.id, file_id))
		const deletePromises = _files2Remove.map(this.removeFile)
		const filesPromises = [...insertPromises, ...deletePromises]
		await Promise.all(filesPromises)
		this.closeUnlockFilesModal()
	}

	async deleteDataList (list_id) {
		try {
			return api.delete(`/project_submission_lists/${list_id}`);
		} catch (error) {
			console.log(error);
		}
	}

	//Functions to modal chat
	modal_chat (status) {
		this.setState({chat_modal: status});
	}

	//Functions to modal delete
	modalDelete (status, submissionList) {
    this.setSelectedSubmissionList(submissionList)
		this.setState({
			modal_delete: status
		});
	}

	modalconfirmStatus (Active, submissionList) {
		this.setState({
			modal_status: Active
		});
	}

	modalDetails (Details,id, submissionList) {
		this.setState({
			modal_details: Details,
			modal_details_id : id
		});
	}

	// Modal "More Info" de la columna Last Sent: muestra la fecha de envio y el
	// detalle de los contactos a los que se les envio esa lista.
	modalLastSent (status, submissionList = null) {
		this.setState({
			modal_last_sent: status,
			last_sent_target: status === "opened" ? submissionList : null
		});
	}

	// Agrupa los contactos de una lista por publisher / categoria para poder
	// listarlos con nombre y email dentro del modal de More Info.
	getSubmissionRecipients = (submissionList) => {
		const contacts = (submissionList && submissionList.contacts) || [];

		if (!contacts.length) {
			return [];
		}

		const hasContact = (contact_type, contact_id) => contacts.some(
			contact => contact.contact_type === contact_type && contact.contact_id === contact_id
		);

		const groups = [];

		(this.state.publishers || []).forEach(publisher => {
			const people = [];

			if (hasContact("publisher", publisher.id)) {
				people.push({
					key: `publisher-${publisher.id}`,
					name: publisher.contact_name || publisher.name || "",
					email: publisher.email || ""
				});
			}

			(publisher.collaborators || []).forEach(collaborator => {
				if (hasContact("publisher_employee", collaborator.id)) {
					people.push({
						key: `publisher_employee-${collaborator.id}`,
						name: collaborator.name || "",
						email: collaborator.email || ""
					});
				}
			});

			if (people.length) {
				groups.push({
					key: `publisher-group-${publisher.id}`,
					title: publisher.name || publisher.contact_name || "",
					people
				});
			}
		});

		(this.state.categories || []).forEach(category => {
			const people = [];

			(category.collaborators || []).forEach(collaborator => {
				if (hasContact("press_contact", collaborator.id)) {
					people.push({
						key: `press_contact-${collaborator.id}`,
						name: collaborator.name || "",
						email: collaborator.email || ""
					});
				}
			});

			if (people.length) {
				groups.push({
					key: `category-group-${category.id}`,
					title: category.name || "",
					people
				});
			}
		});

		return groups;
	};

	modalconfirmSend (status, status2) {
		this.setState({
			modal_send: status,
			send_to: status2
		});
	}
	
	modalconfirmSendClose () {
		this.setState({
			modal_send: 'closed'
		});
	}

	async deleteList (status) {
		const {selectedSubmissionList} = this.state
		this.setState({
			modal_delete: status
		})

		// Antes del delete: despues la API ya no devuelve ni el grupo ni sus
		// archivos, y el historial se quedaria sin ese envio.
		await this.archiveListBeforeDelete(selectedSubmissionList)

		await this.deleteDataList(selectedSubmissionList.id)
		this.setSelectedSubmissionList(null)
		this.loadLists()
	}

	async sendSubmissionListEmail (submissionList) {
		try {
			// await, no return: sin el, el catch de abajo nunca llega a ejecutarse.
			return await api.post(`/project_submission_lists/${submissionList.id}/send`)
		} catch (err) {
			console.log(err)
		}
	}

	//Functions to send the project
	async sendToPublishers () {
		const recipients = this.state.send_to;
		const button = document.querySelector('.project-content .actions .btn-send');

		// "Send All" reparte solo los grupos que faltan: reenviar uno ya enviado
		// no alcanza a nadie, y volver a encolar uno que ya esta en cola lo
		// duplicaria si se pulsa el boton dos veces.
		const toDispatch = recipients === 'all'
			? this.state.submissionLists.filter(list => !list.sent_at && !list.scheduled_at)
			: [];

		if (recipients === 'all' && toDispatch.length === 0) {
			return this.setState({
				modal_send: "closed",
				schedule_error: "Every message group has already been sent or is queued."
			});
		}

		if (button) {
			button.classList.add("load");
		}

		try {
			if (recipients === 'all') {
				await this.dispatchAllStaggered(toDispatch);
			} else {
				await this.sendSubmissionListEmail(recipients);
			}
		} catch (error) {
			console.log(error);
		} finally {
			if (button) {
				button.classList.remove("load");
			}
		}

		this.setState({
			modal_send: "closed",
			modal_submitted: "opened"
		});
		setTimeout(() => {
			this.setState({
				modal_submitted: "closed"
			})
		}, 3000);
		return this.loadLists();
	}

	// ----------------------------------------------------
	// SCHEDULE -------------------------------------------
	// ----------------------------------------------------

	// <input type="datetime-local"> habla en hora local sin zona horaria, asi
	// que ambos sentidos de la conversion pasan por la zona del navegador: la
	// API siempre guarda y devuelve un instante UTC.
	toScheduleInputValue = (date) => {
		const pad = (n) => String(n).padStart(2, '0');

		return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
	}

	// Evita que el selector ofrezca un momento que la API rechazaria igual.
	minScheduleValue = () => this.toScheduleInputValue(new Date())

	// La zona del navegador se muestra junto a cada fecha: la API guarda instantes
	// UTC y cada navegador los traduce a la suya, asi que un "8:00 PM" a secas se
	// lee mal cuando quien agenda y quien revisa estan en paises distintos.
	browserTimeZone = () => {
		try {
			return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
		} catch (error) {
			return "";
		}
	}

	// Version larga para tooltips y modales: hora local, abreviatura de la zona
	// y nombre IANA entre parentesis.
	formatScheduleDate = (value) => {
		const date = new Date(value);

		if (isNaN(date.getTime())) {
			return "";
		}

		const zone = this.browserTimeZone();

		return `${date.toLocaleString(undefined, {timeZoneName: "short"})}${zone ? ` (${zone})` : ""}`;
	}

	// Version corta para el chip de la tabla, donde solo hay sitio para una
	// linea: "Oct 25, 12:00 PM GMT-6". Lleva la abreviatura de la zona en vez del
	// nombre IANA porque el chip recorta con ellipsis; el nombre completo queda en
	// el title, que usa formatScheduleDate.
	formatScheduleDateShort = (value) => {
		const date = new Date(value);

		if (isNaN(date.getTime())) {
			return "";
		}

		return date.toLocaleString(undefined, {
			month: "short",
			day: "numeric",
			hour: "numeric",
			minute: "2-digit",
			timeZoneName: "short"
		});
	}

	onScheduleChange = (list_id, value) => {
		this.setState({
			schedule_inputs: {
				...this.state.schedule_inputs,
				[list_id]: value
			}
		});
	}

	openScheduleModal = (submissionList) => {
		const value = this.state.schedule_inputs[submissionList.id];

		if (!value) {
			return this.setState({schedule_error: "Pick a date and time first."});
		}

		if (new Date(value).getTime() <= Date.now()) {
			return this.setState({schedule_error: "The date and time must be in the future."});
		}

		this.setState({
			modal_schedule: "opened",
			schedule_target: submissionList
		});
	}

	closeScheduleModal = () => {
		this.setState({
			modal_schedule: "closed",
			schedule_target: null
		});
	}

	closeScheduleError = () => this.setState({schedule_error: ""})

	scheduleList = async () => {
		const {schedule_target, schedule_inputs} = this.state;

		if (!schedule_target) {
			return;
		}

		const list_id = schedule_target.id;
		const value = schedule_inputs[list_id];
		this.closeScheduleModal();

		try {
			const response = await api.post(`/project_submission_lists/${list_id}/schedule`, {
				scheduled_at: new Date(value).toISOString()
			});

			// La API responde 200 con {scheduled:false, error} cuando rechaza la fecha.
			if (response.data && response.data.scheduled === false) {
				return this.setState({schedule_error: response.data.error || "Could not schedule this message."});
			}

			await this.setState({
				schedule_inputs: {...this.state.schedule_inputs, [list_id]: ""}
			});

			return this.loadLists();
		} catch (error) {
			console.log(error);
			this.setState({schedule_error: "Could not schedule this message."});
		}
	}

	unscheduleList = async (submissionList) => {
		try {
			await api.post(`/project_submission_lists/${submissionList.id}/unschedule`);

			return this.loadLists();
		} catch (error) {
			console.log(error);
			this.setState({schedule_error: "Could not cancel the schedule."});
		}
	}

	// Tres estados excluyentes: agendado -> chip con boton de cancelar;
	// enviado -> chip con la fecha y hora del envio; ninguno -> selector.
	//
	// Una lista ya enviada no vuelve a ofrecer el selector. Tentaba mostrarlo
	// cuando quedaran contactos con sent_at nulo, pero ese campo no distingue
	// "pendiente" de "nunca se le envia": un contacto con setup "None" lo
	// conserva nulo para siempre, asi que la celda quedaria ofreciendo agendar
	// un envio que no alcanzaria a nadie. Para un seguimiento se crea un nuevo
	// grupo con "Add Message Group".
	renderScheduleCell = (submissionList) => {
		if (submissionList.scheduled_at) {
			return (
				<div className="schedule-field">
					<span className="schedule-chip" title={this.formatScheduleDate(submissionList.scheduled_at)}>
						<span className="schedule-dot"></span>
						<span className="schedule-chip-date">{this.formatScheduleDateShort(submissionList.scheduled_at)}</span>
					</span>
					<button
						className="schedule-icon-btn schedule-cancel"
						title="Cancel schedule"
						aria-label="Cancel schedule"
						onClick={(e) => this.unscheduleList(submissionList)}
					>
						<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18.3 5.7a1 1 0 0 0-1.4 0L12 10.6 7.1 5.7a1 1 0 1 0-1.4 1.4l4.9 4.9-4.9 4.9a1 1 0 1 0 1.4 1.4l4.9-4.9 4.9 4.9a1 1 0 0 0 1.4-1.4L13.4 12l4.9-4.9a1 1 0 0 0 0-1.4z"/></svg>
					</button>
				</div>
			);
		}

		if (submissionList.sent_at) {
			return (
				<div className="schedule-field">
					<span className="schedule-chip is-sent" title={`Sent ${this.formatScheduleDate(submissionList.sent_at)}`}>
						<span className="schedule-dot"></span>
						<span className="schedule-chip-date">{`Sent ${this.formatScheduleDateShort(submissionList.sent_at)}`}</span>
					</span>
				</div>
			);
		}

		return (
			<div className="schedule-field">
				<div className="schedule-input">
					<input
						type="datetime-local"
						name={`schedule-${submissionList.id}`}
						min={this.minScheduleValue()}
						value={this.state.schedule_inputs[submissionList.id] || ""}
						onChange={(e) => this.onScheduleChange(submissionList.id, e.target.value)}
					/>
				</div>
				<button
					className="schedule-icon-btn schedule-submit"
					title="Schedule"
					aria-label="Schedule"
					onClick={(e) => this.openScheduleModal(submissionList)}
				>
					<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 7v5l3.5 2.1.8-1.3-2.8-1.7V7H12z"/><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16z"/></svg>
				</button>
			</div>
		);
	}

	// ----------------------------------------------------
	// STAGGERED DISPATCH ---------------------------------
	// ----------------------------------------------------

	// Ventana de espera entre envios. Debe coincidir con SCHEDULER_MIN_GAP_MS y
	// SCHEDULER_MAX_GAP_MS del backend, que es quien la hace cumplir.
	//
	// Aqui solo sirve para repartir las horas de arranque de cada grupo. El
	// servidor ademas espera lo mismo entre una compania y la siguiente dentro
	// de cada grupo, asi que un grupo con varias companias termina mas tarde de
	// lo que sugiere su hora: esa hora es cuando empieza a salir, no cuando acaba.
	MIN_GAP_SECONDS = 30

	MAX_GAP_SECONDS = 50

	randomGapSeconds = () =>
		this.MIN_GAP_SECONDS + Math.floor(Math.random() * (this.MAX_GAP_SECONDS - this.MIN_GAP_SECONDS + 1))

	// Los tres conteos salen del estado que devuelve la API, no de una variable
	// local, para que el indicador sobreviva a una recarga y refleje lo que el
	// servidor realmente tiene en cola.
	queueCounts = () => {
		const lists = this.state.submissionLists || [];

		const queued = lists.filter(list => !!list.scheduled_at);
		const sent = lists.filter(list => !list.scheduled_at && !!list.sent_at);
		const pending = lists.filter(list => !list.scheduled_at && !list.sent_at);

		const nextAt = queued
			.map(list => new Date(list.scheduled_at).getTime())
			.filter(time => !isNaN(time))
			.sort((a, b) => a - b)[0];

		return {
			total: lists.length,
			queued: queued.length,
			sent: sent.length,
			pending: pending.length,
			nextAt: nextAt === undefined ? null : nextAt
		};
	}

	// Mientras queden grupos en cola, refrescar en silencio para que las filas
	// pasen solas de "agendado" a "enviado" sin que haya que recargar.
	syncQueueWatcher = () => {
		const {queued} = this.queueCounts();

		if (queued > 0 && !this.queueTimer) {
			this.queueTimer = setInterval(() => this.loadLists(true), 10000);
		} else if (queued === 0 && this.queueTimer) {
			clearInterval(this.queueTimer);
			this.queueTimer = null;
		}
	}

	// Envia el primer grupo al momento y le pone a los demas un agendado
	// escalonado, acumulando una espera aleatoria por grupo. Encolar en el
	// servidor en vez de esperar en el navegador significa que cerrar la
	// pestana no deja los grupos restantes sin salir.
	dispatchAllStaggered = async (lists) => {
		let offsetSeconds = 0;

		for (let i = 0; i < lists.length; i++) {
			const list = lists[i];

			this.setState({dispatch_progress: {done: i, total: lists.length}});

			try {
				if (i === 0) {
					await api.post(`/project_submission_lists/${list.id}/send`);
				} else {
					offsetSeconds += this.randomGapSeconds();

					const when = new Date(Date.now() + offsetSeconds * 1000);
					await api.post(`/project_submission_lists/${list.id}/schedule`, {
						scheduled_at: when.toISOString()
					});
				}
			} catch (error) {
				// Un grupo que falle no debe impedir que se encolen los siguientes.
				console.log(error);
			}
		}

		this.setState({dispatch_progress: null});
	}

	// Indicador de la cabecera. Durante el reparto muestra el avance; en reposo,
	// cuantos grupos esperan en cola en el servidor o siguen sin enviarse.
	renderQueueIndicator = () => {
		const {dispatch_progress} = this.state;

		if (dispatch_progress) {
			return (
				<span className="queue-indicator is-working">
					{`Queuing ${dispatch_progress.done + 1} of ${dispatch_progress.total}...`}
				</span>
			);
		}

		const {total, queued, pending, nextAt} = this.queueCounts();

		if (total === 0) {
			return null;
		}

		if (queued > 0) {
			const next = nextAt ? ` - next ${this.formatScheduleDateShort(nextAt)}` : "";

			return (
				<span className="queue-indicator is-queued">
					{`${queued} group${queued === 1 ? "" : "s"} queued${next}`}
				</span>
			);
		}

		if (pending > 0) {
			return (
				<span className="queue-indicator">
					{`${pending} group${pending === 1 ? "" : "s"} pending`}
				</span>
			);
		}

		return <span className="queue-indicator is-done">All groups sent</span>;
	}

	// ----------------------------------------------------
	// ARCHIVO LOCAL DEL HISTORIAL ------------------------
	// ----------------------------------------------------

	// El formato y el almacenamiento viven en services/history-archive: Submission
	// History lee lo mismo que aqui se escribe. Aqui solo queda la parte que es de
	// esta pagina: mantenerlo al dia con la API y marcar lo que se borra.

	// El archivo se lee en cada render del panel, asi que se parsea una vez y se
	// guarda en memoria. La clave va en la cache porque el primer render ocurre
	// antes de que componentDidMount ponga el project_id.
	history_archive = null

	history_archive_key = null

	readHistoryArchive = () => {
		const key = archiveKey(this.state.project_id);

		if (this.history_archive && this.history_archive_key === key) {
			return this.history_archive;
		}

		this.history_archive_key = key;
		this.history_archive = readArchive(this.state.project_id);

		return this.history_archive;
	}

	writeHistoryArchive = (archive) => {
		this.history_archive_key = archiveKey(this.state.project_id);
		this.history_archive = archive;

		writeArchive(this.state.project_id, archive);
	}

	historySnapshot = (list) => snapshotList(list, this.state.project_id)

	// Vuelca al archivo los grupos enviados que devuelve la API y reconcilia: lo
	// que estaba guardado como vivo y ya no viene en la respuesta se borro en otra
	// sesion. `live_ids` sale de la respuesta SIN filtrar, porque loadLists
	// descarta los grupos que se quedaron sin contactos y esos no estan borrados.
	syncHistoryArchive = (lists, live_ids) => {
		const archive = this.readHistoryArchive();

		(lists || []).forEach(list => {
			if (!list.sent_at) {
				return;
			}

			const previous = archive[list.id];
			const snapshot = this.historySnapshot(list);

			// Los archivos se piden aparte y solo al desplegar el panel: mientras no
			// esten cargados hay que conservar los que ya se hubieran guardado.
			if (!list.files && previous) {
				snapshot.files = previous.files || [];
			}

			archive[list.id] = snapshot;
		});

		if (live_ids) {
			Object.keys(archive).forEach(key => {
				const entry = archive[key];

				if (entry && !entry.deleted && !live_ids.has(entry.id)) {
					// Consta que ya no esta, pero no cuando lo borraron.
					entry.deleted = true;
					entry.deleted_at = null;
				}
			});
		}

		this.writeHistoryArchive(archive);
	}

	// Guarda el grupo antes de que la API lo pierda. Si el panel de historial
	// nunca se abrio, sus archivos no estan cargados y se piden ahora: despues del
	// delete ya no queda a quien preguntarle.
	archiveListBeforeDelete = async (list) => {
		if (!list || !list.sent_at) {
			return;
		}

		const archive = this.readHistoryArchive();
		const previous = archive[list.id];

		if (!list.files) {
			try {
				const response = await api.get(`/project_submission_lists/${list.id}/files`);
				list.files = response.data || [];
			} catch (error) {
				console.log(error);
			}
		}

		const snapshot = this.historySnapshot(list);

		if (!list.files && previous) {
			snapshot.files = previous.files || [];
		}

		snapshot.deleted = true;
		snapshot.deleted_at = new Date().toISOString();

		archive[list.id] = snapshot;
		this.writeHistoryArchive(archive);
	}

	// ----------------------------------------------------
	// SENDING HISTORY ------------------------------------
	// ----------------------------------------------------

	// El panel nace plegado y solo pide los archivos de cada grupo la primera vez
	// que se despliega: es una peticion por grupo ya enviado y no tiene sentido
	// pagarlas mientras la tabla esta cerrada.
	toggleHistory = async () => {
		const opening = !this.state.history_open;

		this.setState({history_open: opening});

		if (opening && !this.history_files_ready) {
			await this.loadHistoryFiles();
		}
	}

	// Pide en paralelo los archivos de los grupos ya enviados. Un fallo aislado no
	// vacia el resto de la tabla, pero deja la cache sin marcar lista para que al
	// volver a abrir el panel se reintente en vez de quedarse con datos a medias.
	//
	// `silent` deja el spinner apagado: en un refresco de fondo la tabla ya tiene
	// datos en pantalla y taparla cada pocos segundos seria peor que esperar.
	loadHistoryFiles = async (silent) => {
		this.setState(silent ? {history_error: ""} : {history_loading: true, history_error: ""});

		const lists = (this.state.submissionLists || []).filter(list => !!list.sent_at);
		let failed = 0;

		await Promise.all(lists.map(async (list) => {
			try {
				const response = await api.get(`/project_submission_lists/${list.id}/files`);
				list.files = response.data || [];
			} catch (error) {
				console.log(error);
				list.files = list.files || [];
				failed += 1;
			}
		}));

		this.history_files_ready = failed === 0;

		// Ya con los archivos cargados, el archivo local guarda tambien cuales
		// fueron: si despues se borra el grupo, la columna Files Sent lo conserva.
		this.syncHistoryArchive(lists);

		this.setState({
			history_loading: false,
			history_error: failed ? "Some sent files could not be loaded. Collapse and open the history again to retry." : "",
			// Los archivos se escriben sobre el propio objeto de cada lista, asi que
			// la referencia de submissionLists no cambia: hay que forzar el repintado.
			render_update: !this.state.render_update
		});
	}

	// Compara dos fechas y conserva la mas reciente. Las invalidas se ignoran en
	// vez de propagarse como NaN hasta la celda.
	keepLatestDate = (current, value) => {
		if (!value) {
			return current;
		}

		const time = new Date(value).getTime();

		if (isNaN(time)) {
			return current;
		}

		if (!current || time > new Date(current).getTime()) {
			return value;
		}

		return current;
	}

	// Indice "contact_type-contact_id" -> destinatario de la tabla: a que fila va
	// y por cual de los dos canales entro. El contacto de tipo "publisher" es la
	// cuenta de la compania; los empleados y los contactos de prensa son personas,
	// y por eso alimentan columnas distintas.
	//
	// Se construye de una pasada en vez de buscar contacto por contacto: son 250+
	// publishers con sus empleados y la tabla se recalcula en cada render.
	buildHistoryIndex = () => {
		const index = new Map();

		(this.state.publishers || []).forEach(publisher => {
			const owner = {
				key: `publisher-${publisher.id}`,
				name: publisher.name || publisher.contact_name || "",
				type: "Publisher"
			};

			index.set(`publisher-${publisher.id}`, {
				...owner,
				channel: "company",
				label: publisher.contact_name || publisher.name || ""
			});

			(publisher.collaborators || []).forEach(employee => {
				index.set(`publisher_employee-${employee.id}`, {
					...owner,
					channel: "contact",
					label: employee.name || ""
				});
			});
		});

		(this.state.categories || []).forEach(category => {
			const owner = {
				key: `category-${category.id}`,
				name: category.name || category.contact_name || "",
				type: "Press"
			};

			(category.collaborators || []).forEach(employee => {
				index.set(`press_contact-${employee.id}`, {
					...owner,
					channel: "contact",
					label: employee.name || ""
				});
			});
		});

		return index;
	}

	// Los envios que alimentan la tabla: los grupos que la API sigue devolviendo,
	// mas los que el archivo local tiene marcados como borrados. Mandan los vivos,
	// que vienen recien traidos; el archivo solo aporta lo que ya no existe.
	//
	// Asi, si alguien limpia el localStorage, el historial pierde los borrados
	// pero conserva entero lo que si esta en la API.
	historyEntries = () => {
		const archive = this.readHistoryArchive();

		const live = (this.state.submissionLists || [])
			.filter(list => !!list.sent_at)
			.map(list => ({
				id: list.id,
				sent_at: list.sent_at,
				contacts: list.contacts || [],
				// Mientras el panel no se despliega los archivos no estan cargados;
				// los del archivo local sirven de relleno hasta que lleguen.
				files: list.files || (archive[list.id] && archive[list.id].files) || [],
				deleted: false,
				deleted_at: null
			}));

		const live_ids = new Set(live.map(entry => entry.id));

		const deleted = Object.keys(archive)
			.map(key => archive[key])
			.filter(entry => entry && entry.deleted && !live_ids.has(entry.id));

		return live.concat(deleted);
	}

	// Una fila por destinatario (publisher o categoria de prensa), no por grupo:
	// un mismo publisher puede aparecer en varios grupos y lo que interesa del
	// historial es su ultima fecha, no cada grupo por separado.
	//
	// Solo entran los grupos con sent_at. Los agendados o pendientes todavia no
	// son historial, y mezclarlos pintaria fechas de envios que no han ocurrido.
	buildHistoryRows = () => {
		const owners = this.buildHistoryIndex();
		const fileTitles = new Map((this.state.links || []).map(link => [link.id, link.title]));
		const rows = new Map();

		const rowFor = (owner) => {
			if (!rows.has(owner.key)) {
				rows.set(owner.key, {
					key: owner.key,
					name: owner.name || "Unknown",
					type: owner.type,
					company_sent_at: null,
					contact_sent_at: null,
					recipients: [],
					files: new Map(),
					send_ids: new Set(),
					deleted_sends: []
				});
			}

			return rows.get(owner.key);
		};

		this.historyEntries().forEach(entry => {
			(entry.contacts || []).forEach(contact => {
				const owner = owners.get(`${contact.contact_type}-${contact.contact_id}`);

				if (!owner) {
					return;
				}

				// sent_at del contacto es por destinatario y es lo mas fiel; cuando la
				// API no lo trae, la fecha del grupo es cuando salio el envio.
				const sent_at = contact.sent_at || entry.sent_at;

				if (!sent_at) {
					return;
				}

				const row = rowFor(owner);

				if (owner.channel === "company") {
					row.company_sent_at = this.keepLatestDate(row.company_sent_at, sent_at);
				} else {
					row.contact_sent_at = this.keepLatestDate(row.contact_sent_at, sent_at);
				}

				if (owner.label && !row.recipients.includes(owner.label)) {
					row.recipients.push(owner.label);
				}

				// Un grupo cuenta una sola vez por fila aunque le llegara a varios de
				// sus contactos: lo que se cuenta son envios, no destinatarios.
				if (!row.send_ids.has(entry.id)) {
					row.send_ids.add(entry.id);

					if (entry.deleted) {
						row.deleted_sends.push(entry);
					}
				}

				// Map por file_id: el mismo archivo repetido en dos grupos cuenta una vez.
				(entry.files || []).forEach(listFile => {
					row.files.set(listFile.file_id, fileTitles.get(listFile.file_id) || `File #${listFile.file_id}`);
				});
			});
		});

		return Array.from(rows.values())
			.map(row => ({
				...row,
				files: Array.from(row.files.values()),
				sends_total: row.send_ids.size,
				sends_deleted: row.deleted_sends.length,
				deleted_detail: row.deleted_sends
					.map(entry => entry.deleted_at
						? `Sent ${this.formatScheduleDateShort(entry.sent_at)}, deleted ${this.formatScheduleDateShort(entry.deleted_at)}`
						: `Sent ${this.formatScheduleDateShort(entry.sent_at)}, deleted from another session`)
					.join(" | "),
				this_game_sent_at: this.keepLatestDate(row.company_sent_at, row.contact_sent_at),
				// Pendiente de un endpoint de historial entre proyectos: con lo que
				// carga esta pagina solo se puede saber de este juego.
				any_game_sent_at: null
			}))
			.sort((a, b) => new Date(b.this_game_sent_at).getTime() - new Date(a.this_game_sent_at).getTime());
	}

	// Chip corto con la fecha y tooltip con la version larga, igual que la columna
	// Schedule del dashboard.
	renderHistoryDate = (value, empty_title) => {
		if (!value) {
			return <span className="history-empty" title={empty_title || ""}>--</span>;
		}

		return (
			<span className="history-chip" title={this.formatScheduleDate(value)}>
				{this.formatScheduleDateShort(value)}
			</span>
		);
	}

	// Estado del destinatario en el historial: si los grupos por los que recibio
	// este juego siguen existiendo o se borraron. Borrar un grupo no borra el
	// hecho de haberselo enviado, solo lo marca; las fechas de arriba se quedan.
	renderHistoryStatus = (row) => {
		if (!row.sends_deleted) {
			return <span className="history-status is-active">Active</span>;
		}

		if (row.sends_deleted === row.sends_total) {
			return <span className="history-status is-deleted" title={row.deleted_detail}>Deleted</span>;
		}

		// Label corto porque la columna es estrecha; el desglose va en el tooltip.
		return (
			<span className="history-status is-partial" title={row.deleted_detail}>
				{`${row.sends_deleted}/${row.sends_total} deleted`}
			</span>
		);
	}

	renderHistoryFiles = (files) => {
		if (!files.length) {
			return <span className="history-empty">--</span>;
		}

		return (
			<span className="badge history-files" title={files.join(", ")}>
				{`${files.length} file${files.length === 1 ? "" : "s"}`}
			</span>
		);
	}

	// Tabla plegable bajo el dashboard. Reusa las mismas piezas de la tabla de
	// arriba (title-content, project-content-header, publisher-selection) para que
	// las dos se lean como una sola pagina.
	renderHistory = () => {
		const open = this.state.history_open;
		// El conteo se calcula tambien con el panel plegado: asi la cabecera dice
		// si hay historial que mirar sin obligar a abrirlo. Las filas no dependen
		// de los archivos, que son lo unico que se pide al desplegar.
		const rows = this.buildHistoryRows();

		return (
			<div className="project-content row history-content">
				<button
					className={`title-content with-indicator history-toggle ${open ? "opened" : ""}`}
					onClick={this.toggleHistory}
					aria-expanded={open}
				>
					<span>Sending History</span>
					<span className="history-toggle-meta">
						{ !this.state.history_loading &&
							<span className="queue-indicator">
								{`${rows.length} recipient${rows.length === 1 ? "" : "s"}`}
							</span>
						}
						<span className="history-caret" aria-hidden="true"></span>
					</span>
				</button>

				{ open &&
					<React.Fragment>
						<div className="project-content-header history-header">
							<div className="col flex align-center sm-12 md-2 lg-2">
								<p className="title">Recipient</p>
							</div>
							<div className="col flex align-center sm-12 md-2 lg-2">
								<p className="title">Last Send To Company</p>
							</div>
							<div className="col flex align-center sm-12 md-2 lg-2">
								<p className="title">Last Send To Contact</p>
							</div>
							<div className="col flex align-center sm-12 md-1 lg-1">
								<p className="title">Files Sent</p>
							</div>
							<div className="col flex align-center sm-12 md-2 lg-2">
								<p className="title">This Game Sent</p>
							</div>
							<div className="col flex align-center sm-12 md-2 lg-2">
								<p className="title">Any Game Sent</p>
							</div>
							<div className="col flex align-center sm-12 md-1 lg-1">
								<p className="title">Status</p>
							</div>
						</div>

						{ this.state.history_loading &&
							<span className="laoding-lists"></span>
						}

						{ !this.state.history_loading &&
							<div className="project-content-body">
								{ this.state.history_error !== "" &&
									<div className="new-selection history-notice">
										<div className="col flex align-center sm-12">
											<p className="text">{this.state.history_error}</p>
										</div>
									</div>
								}

								{ rows.length === 0 &&
									<div className="new-selection history-notice">
										<div className="col flex align-center sm-12">
											<p className="text">No sends recorded for this game yet.</p>
										</div>
									</div>
								}

								{ rows.map(row => (
									<div
										className={`publisher-selection history-row ${row.sends_deleted === row.sends_total ? "is-deleted" : ""}`}
										key={row.key}
									>
										<div className="col flex align-center sm-12 md-2 lg-2 history-recipient">
											<p className="text" title={row.recipients.join(", ")}>{row.name}</p>
											<span className="badge-collabs history-type">{row.type}</span>
										</div>

										<div className="col flex align-center sm-12 md-2 lg-2">
											<span className="history-label">Last Send To Company</span>
											{this.renderHistoryDate(row.company_sent_at, "The company account has not received this game")}
										</div>

										<div className="col flex align-center sm-12 md-2 lg-2">
											<span className="history-label">Last Send To Contact</span>
											{this.renderHistoryDate(row.contact_sent_at, "No individual contact has received this game")}
										</div>

										<div className="col flex align-center sm-12 md-1 lg-1">
											<span className="history-label">Files Sent</span>
											{this.renderHistoryFiles(row.files)}
										</div>

										<div className="col flex align-center sm-12 md-2 lg-2">
											<span className="history-label">This Game Sent</span>
											{this.renderHistoryDate(row.this_game_sent_at)}
										</div>

										<div className="col flex align-center sm-12 md-2 lg-2">
											<span className="history-label">Any Game Sent</span>
											{this.renderHistoryDate(row.any_game_sent_at, "Cross-project history is not available yet")}
										</div>

										<div className="col flex align-center sm-12 md-1 lg-1">
											<span className="history-label">Status</span>
											{this.renderHistoryStatus(row)}
										</div>
									</div>
								))}
							</div>
						}
					</React.Fragment>
				}
			</div>
		);
	}


	renderCheck = (props) => {
		const {selectedContacts} = this.state;
		const key = `${props.contact_type}-${props.contact_id}`;
		let checked = !!selectedContacts[key] ? 'checked' : '';

		if (props.contact_type === 'publisher_all') {
			const publisher = (this.state.publishers || []).find(item => item.id === props.contact_id);
			checked = publisher && this.publisherAllContactsSelected(publisher) ? 'checked' : '';
		} else if (props.contact_type === 'press_contact_all') {
			const category = (this.state.categories || []).find(item => item.id === props.contact_id);
			checked = category && this.categoryAllContactsSelected(category) ? 'checked' : '';
		}

		// renderCheck se invoca dentro de .map(), asi que el boton que devuelve es
		// el elemento de la lista y necesita llevar la key el mismo.
		return (
			<button key={props.itemKey || `${key}-btn`} className={`check ${checked}`} onClick={props.onClick}>
				<p className="text">{props.label}</p>
			</button>
		);
	}

	newSubmissionListObject () {
		return {
			id: 0,
			project_id: this.state.project_id,
			contacts: [],
		}
	}

	render() {
		const {state} = this
		const userType = this.state.user_type;

		let banner;
		if(this.state.banner_src) {
			banner = <img src={this.state.banner_src} alt={this.state.banner_title}/>
		} else {
			banner = <span className="without-banner">Without banner</span>
		}

		// Destinatarios de la lista abierta en el modal de "More Info" (Last Sent).
		const lastSentRecipients = this.state.last_sent_target
			? this.getSubmissionRecipients(this.state.last_sent_target)
			: [];

		//Unlock files butons
		const availableLinks = this.state.available_links;
		function LinkAvaliable(props) {
			const {link, onClickAvaliable, onClickUnavaliable} = props
			const available =  availableLinks.includes(link.id)//!!selectedSubmissionList.files.find(listFile => listFile.file_id === link.id)
			const bts = <div className="link-col" key={link.id}>
				<button onClick={onClickAvaliable} className={`btn grey ${available ? "avaliable" : ""}`}>Avaliable</button>
				<button onClick={onClickUnavaliable} className={`btn grey ${!available ? "unavaliable" : ""}`}>Unavaliable</button>
			</div>
			return bts
		}

		//List of contacts selecteds of Publishers
		function ButtonPublisherList (props) {
			
			const {submissionList} = props
			if (!submissionList.contacts.length) {
				return null;
			}

			const typesNameResolver = {
				publisher: (contact) => {
					const publisher = state.publishers.find((publisher) => publisher.id === contact.contact_id)
					if (publisher) {
						return publisher.contact_name || publisher.name || ''
					}
				},
				publisher_employee: (contact) => {
					for (const publisher of state.publishers) {
						const employee = publisher.collaborators.find(collaborator => collaborator.id === contact.contact_id)
						if (employee) {
							return employee.name
						}
					}
					return ''
				},
				press_contact: (contact) => {
					for (const category of state.categories) {
						const employee = category.collaborators.find(collaborator => collaborator.id === contact.contact_id)
						if (employee) {
							return employee.name
						}
					}
				}
			}

			const contactsName = submissionList.contacts.map((contact) => {
				const name = typesNameResolver[contact.contact_type](contact)
				return name || ''
			})

			return <button className="link-col btn btn-publishers" key={submissionList.id} onClick={props.onClick}>
				{contactsName.join(', ')}
			</button>;	
		}
		
        return (
			<div data-page="project">
				<Header />

				<TitlePage title="Follow-Up Projects"/>

				
				<div className="container-fluid" data-component="project-content">
					<div className="container-fluid">
						<div className="project-header row">
							<h1 className="title">Dashboard of {this.state.project_title}</h1>
							<div className={`chat-modal ${this.state.chat_modal}`}>
								<div className="chat-container">
									<div className="chat-header">
										<p className="chat-name">Jhon Doe</p>
										<button onClick={e => this.modal_chat('closed')} className="btn btn-close"></button>
									</div>

									<div className="chat-content">
										<div className="message-received">
											<div className="profile-image">
												<img src={logoPartner} alt={`logo ${this.state.company_name}`}/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="project-content row">
							<div className="title-content with-indicator">
								<span>Message Center</span>
								{this.renderQueueIndicator()}
							</div>
							<div className="project-content-header">
								<div className="col flex align-center sm-12 md-5 lg-3">
									{ this.state.user_type === "admin" &&
										<p className="title">Publishers</p>
									}
									{ this.state.user_type === "normal" &&
										<p className="title">Contacts</p>
									}
								</div>
								<div className="col flex align-center sm-4 md-2 lg-1">
									<p className="title">Message</p>
								</div>
								<div className="col flex align-center sm-4 md-2 lg-1">
									<p className="title">Files to send</p>
								</div>
								<div className="col flex align-center sm-4 md-2 lg-2">
									<p className="title">Last Sent</p>
								</div>
								<div className="col flex align-center sm-4 md-2 lg-3">
									<p className="title">Actions</p>
								</div>
								<div className="col flex align-center sm-4 md-2 lg-2">
									<p className="title">Schedule</p>
								</div>
							</div>

							{ this.state.loading_lists &&
								<span className="laoding-lists"></span>
							}

							{ !this.state.loading_lists && this.state.lists_error !== "" &&
								<div className="project-content-body">
									<div className="new-selection">
										<div className="col flex align-center sm-12 md-8 lg-9">
											<p className="text">{this.state.lists_error}</p>
										</div>
										<div className="col flex align-center sm-12 md-4 lg-3">
											<button className="btn blue" onClick={(e) => this.loadLists()}>Retry</button>
										</div>
									</div>
								</div>
							}

							{ !this.state.loading_lists && this.state.lists_error === "" &&
								<div className="project-content-body">
									{ this.state.submissionLists.map(submissionList => (
										<div className="publisher-selection has-schedule" key={submissionList.id}>
											<div className="col flex align-center sm-12 md-5 lg-3">
												<ButtonPublisherList id={submissionList.id} submissionList={submissionList} onClick={(e) => this.modalPublishers("opened", submissionList)}/>
											</div>
											<div className="col flex align-center sm-4 md-2 lg-1">
												<button className="btn-icon btn-message" onClick={(e) => this.openMessageModal(submissionList)} title="Write message">
													<svg xmlns="http://www.w3.org/2000/svg" viewBox="-21 -47 682.667 682"><path d="M552.012-1.332H87.988C39.473-1.332 0 38.133 0 86.656V370.63c0 48.414 39.3 87.816 87.676 87.988V587.48l185.191-128.863h279.145c48.515 0 87.988-39.472 87.988-87.988V86.656c0-48.523-39.473-87.988-87.988-87.988zm50.488 371.96c0 27.837-22.648 50.49-50.488 50.49h-290.91l-135.926 94.585v-94.586H87.988c-27.84 0-50.488-22.652-50.488-50.488V86.656c0-27.843 22.648-50.488 50.488-50.488h464.024c27.84 0 50.488 22.645 50.488 50.488zm0 0" data-original="#000000"/><path d="M171.293 131.172h297.414v37.5H171.293zm0 0M171.293 211.172h297.414v37.5H171.293zm0 0M171.293 291.172h297.414v37.5H171.293zm0 0" data-original="#000000"/></svg>
												</button>
											</div>

											<div className="col flex align-center sm-3 md-2 lg-1">
												<button className="btn-icon btn-unlock" onClick={(e) => this.openUnlockFilesModal(submissionList)} title="Unlock Files">
													<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M334.974 0c-95.419 0-173.049 77.63-173.049 173.049 0 21.213 3.769 41.827 11.211 61.403L7.672 399.928a12.613 12.613 0 00-3.694 8.917v90.544c0 6.965 5.646 12.611 12.611 12.611h74.616a12.61 12.61 0 008.91-3.686l25.145-25.107a12.61 12.61 0 003.701-8.925v-30.876h30.837c6.965 0 12.611-5.646 12.611-12.611v-12.36h12.361c6.964 0 12.611-5.646 12.611-12.611v-27.136h27.136c3.344 0 6.551-1.329 8.917-3.694l40.121-40.121c19.579 7.449 40.196 11.223 61.417 11.223 95.419 0 173.049-77.63 173.049-173.049C508.022 77.63 430.393 0 334.974 0zm0 320.874c-20.642 0-40.606-4.169-59.339-12.393-4.844-2.126-10.299-.956-13.871 2.525-.039.037-.077.067-.115.106l-42.354 42.354h-34.523c-6.965 0-12.611 5.646-12.611 12.611v27.136H159.8c-6.964 0-12.611 5.646-12.611 12.611v12.36h-30.838c-6.964 0-12.611 5.646-12.611 12.611v38.257l-17.753 17.725H29.202v-17.821l154.141-154.14c4.433-4.433 4.433-11.619 0-16.051s-11.617-4.434-16.053 0L29.202 436.854V414.07l167.696-167.708c.038-.038.067-.073.102-.11 3.482-3.569 4.656-9.024 2.53-13.872-8.216-18.732-12.38-38.695-12.38-59.33 0-81.512 66.315-147.827 147.827-147.827S482.802 91.537 482.802 173.05c-.002 81.51-66.318 147.824-147.828 147.824z"/><path d="M387.638 73.144c-26.047 0-47.237 21.19-47.237 47.237s21.19 47.237 47.237 47.237 47.237-21.19 47.237-47.237-21.189-47.237-47.237-47.237zm0 69.252c-12.139 0-22.015-9.876-22.015-22.015s9.876-22.015 22.015-22.015 22.015 9.876 22.015 22.015-9.876 22.015-22.015 22.015z"/></svg>
												</button>
											</div>

											<div className="col flex align-center sm-3 md-2 lg-2">
												<button
													className="btn blue btn-more-info"
													onClick={(e) => this.modalLastSent("opened", submissionList)}
													title="Sending details"
												>
													More Info
												</button>
											</div>

											<div className="col flex align-center sm-5 md-3 lg-3 body-actions">
												<button className="btn blue" onClick={(e) => this.modal_preview(submissionList)}>Preview</button>
												<button className="btn blue btn-send" onClick={e => this.modalconfirmSend('opened',submissionList)}>Send Now</button>
												<button className="btn green" onClick={e => this.modalconfirmStatus('opened')}>Details</button>
												<button className="btn delete" onClick={(e) => this.modalDelete("opened", submissionList)}>Delete</button>
											</div>
											<div className="col flex align-center sm-12 md-12 lg-2">
												{this.renderScheduleCell(submissionList)}
											</div>
										</div>
									))}
								

									<div className="new-selection">
										<div className="col flex align-center sm-12 md-3 lg-3">
											<button className="btn blue" onClick={(e) => this.modalPublishers("opened")}>
												Add Message Group
											</button>
										</div>
									</div>
								</div>
							}

							<div className="actions">
								<div className="col flex align-center sm-12 md-5 lg-6">
									<Link to={`/shipping-management/${this.state.company_id}/${this.state.project_id}`} className="btn">Exit</Link>
									{/* <Link to={`/email-scheduler/${this.state.company_id}/${this.state.project_id}`} className="btn" title="Schedule an Email">Schedule</Link>
									<a href="http://mailtrack.seat7entertainment.com/" target='_blank'><button className="btn">Track</button></a>
									*/}
									<button className="btn blue btn-send" onClick={e => this.modalconfirmSend('opened','all')}>Send All</button>
								</div>
							</div>
						</div>

						{this.renderHistory()}
					</div>
				</div>

        { this.state.modal_publishers === 'opened' && 
		<div data-component="modal" className={`modal-project-management opened`}>
			<div className="modal-container">
			<div className="modal-header">
				{ this.state.user_type === "admin" ? (
				<p className="text">Select Publishers</p>
				) : (
				<p className="text">Select Contacts</p>
				)}
				<button onClick={() => this.modalPublishers('closed')} className="btn btn-close"></button>
			</div>

			<div className="modal-content modal-list-publishers">
				<div className="list-publishers-header">
				{ this.state.user_type === "admin" && (
					<div>
					<button className="btn toggle-type-list" onClick={() => this.toggleListType('publishers')}>
						Publisher List
					</button>
					<button className="btn toggle-type-list" onClick={() => this.toggleListType('selectedPublishers')}>
						Publisher Selected
					</button>


					&nbsp;
					</div>
				)}

				<div className="search">
					<Search onSubmit={this.onSearchSubmit} placeholder="Search" value={this.state.search} onChange={this.onSearchChange}/> 
				</div>
				</div>

				{/* Lista de publishers completos */}
				
					
					
					
				
				{this.state.type_list === "publishers" && (
					<div className="list-publishers-content new-list">
						{this.filterBySearch(this.state.publishers || []).map(publisher => {
						// Verifica si el publisher ya está seleccionado
						const isSelected = this.state.selectedPublishers.some(p => p.id === publisher.id);

						return (
							<div
							key={publisher.id}
							className={`item ${isSelected ? "selected-item" : ""}`}
							>
							{this.renderCheck({
								itemKey: `publisher-all-${publisher.id}`,
								onClick: () => this.toggleAllPublisherContacts(publisher),
								label: publisher.name,
								contact_type: "publisher_all",
								contact_id: publisher.id
							})}

							<button
								className="badge-details"
								onClick={() => this.modalDetails("opened", publisher.id)}
							>
								Details
							</button>
							&nbsp;
							<span className="badge">{publisher.tags}</span>
							&nbsp;
							{isSelected && <span className="badge" style={{ background: "#0a0" }}>Selected</span>}

							<br />
							<h5 style={{ color: "#1141de", padding: "1px" }}>Company Contacts</h5>
							<div>
								<span className="badge-collabs">
								{`${publisher.contact_name || publisher.name} - ${publisher.email}`}
								</span>
								<br />
								{publisher.collaborators && publisher.collaborators.length > 0 ? (
								publisher.collaborators.map((collaborator, index) => (
									<span
									className="badge-collabs"
									style={{ marginBottom: "2px" }}
									key={collaborator.email}
									>
									{`${collaborator.name} ( ${collaborator.email} )`}
									{index < publisher.collaborators.length - 1 && <br />}
									</span>
								))
								) : (
								<div>No collaborators</div>
								)}
								<br />
							</div>
							</div>
						);
						})}
					</div>
					)}

					{/* Lista de publishers seleccionados */}
					{this.state.type_list === "selectedPublishers" && (
					<div className="list-publishers-content new-list">
						{this.state.selectedPublishers && this.state.selectedPublishers.length > 0 ? (
						this.state.selectedPublishers.map(pub => (
							<div key={`selected-${pub.id}`} className="item">
							<strong>{pub.name}</strong> &nbsp;
							<span className="badge">{pub.tags}</span>

							<div>
								{pub.collaborators && pub.collaborators.length > 0 ? (
								pub.collaborators.map(collab => (
									<div key={`collab-${collab.id || collab.email}`}>
									{collab.name} - {collab.email}
									</div>
								))
								) : (
								<div>No contacts</div>
								)}
							</div>

							<button
								onClick={() => this.toggleAllPublisherContacts(pub)}
								style={{ marginTop: "5px" }}
							>
								Remove
							</button>
							</div>
						))
						) : (
						<div style={{ padding: "10px", color: "black" }}>
							No publishers selected
						</div>
						)}
					</div>
					)}


				{/* Lista de categorías */}
				{this.state.type_list === "categories" && (
				<div className="list-publishers-content new-list">
					{this.filterBySearch(this.state.categories || []).map(publisher => (
					<div key={publisher.id} className="item">
						{this.renderCheck({
						itemKey: `press_contact-all-${publisher.id}`,
						onClick: () => this.toggleAllCategoryContacts(publisher),
						label: publisher.name,
						contact_type: 'press_contact_all',
						contact_id: publisher.id
						})}

						<div className="collaborators-list categories-list">
						{(publisher.collaborators || []).map(collaborator => (
							this.renderCheck({
							itemKey: `press_contact-${collaborator.id}`,
							onClick: () => this.toggleSelectContact('press_contact', collaborator.id, collaborator.email),
							label: `${collaborator.name} - ${collaborator.email}`,
							contact_type: 'press_contact',
							contact_id: collaborator.id
							})
						))}
						</div>
					</div>
					))}
				</div>
				)}

				<div className="save-container">
				<button className="link" onClick={() => this.saveListContacts()}>Save</button>
				</div>
			</div>
			</div>
		</div>
		}

				{this.state.modal_message === 'opened' &&
					<div data-component="modal" className={`modal-project-management opened`}>				
						<div className="modal-container">
							<div className="modal-header">
								<p className="text">Message</p>
								<button onClick={e => this.closeMessageModal()} className="btn btn-close"></button>
							</div>

							<div className="modal-content modal-write-message with-ck-editor">
								<form action="">
									<input
										id="subject"
										name="subject"
										type="text"
										placeholder="Subject:"
										//value={this.state.subject}
										value={this.state.subject || this.state.project_title + " " + "("+this.state.company_name + ")"}
										onChange={e => this.onChange(e)}
									/>
									  
									<CKEditor
										editor={ ClassicEditor }
										data={this.state.message}
										onChange={ ( event, editor ) => {
											const data = editor.getData();
											this.setState({message: data});
										}}
									/>
									<button type="submit" className="btn blue btn-save" onClick={(e) => this.saveMessage(e)}>Save</button>
								</form>
							</div>
						</div>
					</div>
				}
				{
					this.state.modal_unlock_files === 'opened' &&
					<div data-component="modal" className={`modal-project-management opened`}>
						<div className="modal-container">
							<div className="modal-header">
								<p className="text">Unlock Files</p>
								<button onClick={e => this.closeUnlockFilesModal()} className="btn btn-close"></button>
							</div>

							<div className="modal-content modal-unlock-files">
								<div className="files-header">
									<div className="col flex align-center sm-12 lg-3">
											<p className="title">Title</p>
									</div>
									<div className="col flex align-center sm-12 lg-5">
									<p className="title">Description</p>
									</div>
									<div className="col flex align-center header-action sm-12 lg-4">
											<p className="title">Action</p>
									</div>
								</div>
								<div className="list-files">
									{this.state.links.map(link => (
										<div className="link-container" key={`collaborator-${link.id}`}>
											<div className="col flex align-center sm-12 md-6 lg-3">
												<div className="link-col"><p className="text">{link.title}</p></div>
											</div>
											<div className="col flex align-center sm-12 md-12 lg-5">
												<div className="link-col description">
													<p className="text">{link.description}</p>
													<a href={link.file_url} target="blank" className="btn view">View</a>
												</div>
											</div>
											<div className="col flex align-center body-action sm-12 md-6 lg-4">
												<LinkAvaliable
													link={link}
													onClickAvaliable={e => this.avaliableLink(link, true)}
													onClickUnavaliable={e => this.avaliableLink(link, false)}
												/>
											</div>
										</div>
									))}
								</div>

								<div className="save-container">
									<button className="link" onClick={e => this.saveAvaliableLinks("closed")}>Save</button>
								</div>
							</div>
						</div>
					</div>
				}

				{ this.state.modal_preview === 'opened' &&
					<div data-component="modal" className={`modal-preview opened`}>
						<div className="content">
							<button onClick={e => this.closePreviewEmailModal()} className="btn btn-close"></button>
							<EmailPreview project_title={this.state.project_title} company={this.state.company_name} subject={this.state.preview_subject} cc={this.state.preview_cc} default_message={this.state.default_message} message={this.state.preview_message}/>
						</div>
					</div>
				}

				{ this.state.modal_send === 'opened' &&
					<div data-component="modal" className={`modal-cancel opened`}>
						<div className="content">
							<p className="text">
								You are about to send this email to the accounts selected. <br/>
								{ this.state.send_to === 'all' &&
									<span>
										The first group goes out now and the rest follow gradually: the 
										server waits 30 to 50 seconds between one company and the next, 
										so the delivery does not look like a burst to spam filters. A 
										project with many companies can take a while to finish. You can 
										close this page: the queue runs on the server. <br/>
									</span>
								}
								<span className="red-text">This action cannot be undone.</span> <br/>
								<b>Are you sure you want to continue?</b>
							</p>
							<button onClick={e => this.modalconfirmSendClose('closed')} className="btn grey">No</button>
							<button onClick={(e) => this.sendToPublishers()} to="/projects" className="btn blue-light">Yes</button>
						</div>
					</div>
				}

				{ this.state.modal_schedule === 'opened' && this.state.schedule_target &&
					<div data-component="modal" className={`modal-cancel opened`}>
						<div className="content">
							<p className="text">
								This message will be sent automatically on <br/>
								<b>{this.formatScheduleDate(this.state.schedule_inputs[this.state.schedule_target.id])}</b>. <br/>
								You can cancel it from the Schedule column until then. <br/>
								<b>Are you sure you want to continue?</b>
							</p>
							<button onClick={e => this.closeScheduleModal()} className="btn grey">No</button>
							<button onClick={e => this.scheduleList()} className="btn blue-light">Yes</button>
						</div>
					</div>
				}

				{ this.state.schedule_error !== "" &&
					<div data-component="modal" className={`modal-cancel opened`}>
						<div className="content">
							<h3 className="text">{this.state.schedule_error}</h3>
							<button onClick={e => this.closeScheduleError()} className="btn grey">Ok</button>
						</div>
					</div>
				}

				{ this.state.modal_status === 'opened' &&
					<div data-component="modal" className={`modal-cancel opened`}>
						<div className="content">
							<h3 className="text">
								Email is Active For The Selected Publishers.
							</h3>
							<button onClick={e => this.modalconfirmStatus('closed')} className="btn grey">Ok</button>
						</div>
					</div>
				}

				{ this.state.modal_details === 'opened' &&
					<div data-component="modal" className={`modal-cancel opened`}>
						<div className="content">
							<div className="text">
									<h4>
										Publisher's Contacts
									</h4>

									{ this.state.type_list === "publishers" &&
										<div className={`list-publishers-content new-list`}>
											{ this.state.publishers.map( publisher => (
												<div key={publisher.id} className={`item`}>
													{ this.state.user_type === "admin" && publisher.id == state.modal_details_id &&
														<div className="collaborators-list">
															{this.renderCheck({
																itemKey: `details-${publisher.id}`,
																label: `${publisher.contact_name} (${publisher.email})`
															})}
															<br/>
															{(publisher.collaborators || []).map(collaborator => (
																this.renderCheck({
																	itemKey: `details-collaborator-${collaborator.id}`,
																	label: `${collaborator.name} (${collaborator.email})`
																})
															))
															}
														</div>
													}
												</div>
											))}
										</div>
									}
								</div>
							<button onClick={e => this.modalDetails('closed')} className="btn blue-light">Close</button>
						</div>
					</div>
				}

				{ this.state.modal_last_sent === 'opened' && this.state.last_sent_target &&
					<div data-component="modal" className={`modal-cancel modal-last-sent opened`}>
						<div className="content">
							<div className="text">
								<h4>
									Last Sent Details
								</h4>

								<p className="last-sent-resume">
									{`${this.state.last_sent_target.sent_at
										? `Sent on ${this.formatScheduleDate(this.state.last_sent_target.sent_at)}`
										: "Project not sent"} to ${this.state.company_name}`}
								</p>

								<div className={`list-publishers-content new-list`}>
									{ lastSentRecipients.length === 0 &&
										<div className="item">
											<p className="text">This group has no contacts yet.</p>
										</div>
									}

									{ lastSentRecipients.map(group => (
										<div key={group.key} className={`item`}>
											<p className="text">{group.title}</p>

											<div className="collaborators-list">
												{group.people.map(person => (
													<p className="text" key={person.key}>
														{person.email ? `${person.name} (${person.email})` : person.name}
													</p>
												))}
											</div>
										</div>
									))}
								</div>
							</div>
							<button onClick={e => this.modalLastSent('closed')} className="btn blue-light">Close</button>
						</div>
					</div>
				}

				{ this.state.modal_delete === 'opened' &&
					<div data-component="modal" className={`modal-cancel opened`}>
						<div className="content">
							<p className="text">If you proceed you will lose all data saved in this list!<br /><b>Are you sure you want to delete this group?</b></p>
							<button onClick={e => this.modalDelete('closed')} className="btn grey">No</button>
							<button onClick={e => this.deleteList('closed', this.state.selectedSubmissionList)} to="/projects" className="btn blue-light">Yes</button>
						</div>
					</div>
				}
				
				{ this.state.modal_submitted === 'opened' &&
					<div data-component="modal" className={`modal-cancel modal_submitted opened`}>
						<div className="content">
							<p className="text">
								<b>All Done.</b>
								<br />
								<b>Sending Messages Successfully... <span className="loader-details"></span></b>
							</p>
						</div>
					</div>
				}
				
			</div>
		)
	};
}